<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          v-model="prop.form.plateNumberInfo"
          @change="handleChange"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import ChooseCar from 'components/choose/car';
import { annualReviewCarList } from 'api/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      otherFormData: {
        plateNumber: '',
        vehicleCode: '',
        orgId: '',
        licenceType: '',
        vehicleOwnerShip: '',
        vehicleLength: '',
        tireNumber: '',
        vehicleOrigin: '',
      },
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            default: {},
            slot: true,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            disabled: true,
          },
          {
            label: '车辆类型',
            value: 'licenceTypeName',
            type: 'input',
            disabled: true,
          },
          {
            label: '车辆性质',
            value: 'vehicleOwnerShipName',
            type: 'input',
            disabled: true,
          },
          {
            label: '品牌名称',
            value: 'brandModelName',
            type: 'input',
            disabled: true,
          },
          {
            label: '车长',
            value: 'vehicleLengthName',
            type: 'input',
            disabled: true,
          },
          // {
          //   label: '马力',
          //   value: 'horsePower',
          //   type: 'input',
          //   disabled: true,
          // },
          // {
          //   label: '车身颜色',
          //   value: 'bodyColor',
          //   type: 'input',
          //   disabled: true,
          // },
          {
            label: '轴数',
            value: 'axleNumber',
            type: 'input',
            disabled: true,
          },
          // {
          //   label: '单/双胎',
          //   value: 'tireNumberName',
          //   type: 'input',
          //   disabled: true,
          // },
          // {
          //   label: '轮胎型号',
          //   value: 'tyreType',
          //   type: 'input',
          //   disabled: true,
          // },
          {
            label: '发动机号',
            value: 'engineNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '车架号',
            value: 'vinNo',
            type: 'input',
            disabled: true,
          },
          {
            label: '配置',
            value: 'vehicleOriginName',
            type: 'input',
            disabled: true,
          },
          {
            label: '使用状态',
            value: 'vehicleState',
            type: 'input',
            disabled: true,
          },
        ],
        rules: {
          plateNumberInfo: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    handleChange () {
      const plateNumberInfo = this.$refs.baseForm.getVal('plateNumberInfo');
      this.setFormValFromData(this.otherFormData, plateNumberInfo);
      for (let name in plateNumberInfo) {
        if (name) {
          for (let item of this.baseForm.form) {
            if (item.value === name) {
              this.$refs.baseForm.setVal(name, plateNumberInfo[name] || ' ');
            }
          }
        }
      }
      this.$emit('plateNumberChange', plateNumberInfo);
    },
    // 从车辆预警列表的处理页面进来
    async jumpFromWarn () {
      const plateNumber = this.$route.query.plateNumber;
      if (plateNumber) {
        const certificatesInsuranceType = this.$route.query.certificatesInsuranceType;
        this.$refs.baseForm.setVal('certificatesInsuranceType', certificatesInsuranceType);
        const res = await annualReviewCarList({ plateNumber: decodeURI(plateNumber) });
        if (!res.failed) {
          if (res.items && res.items[0]) {
            const vehicleInfo = res.items[0];
            this.$emit('getVehicleInfo', vehicleInfo);
            for (let item of this.baseForm.form) {
              if (item.value) {
                this.$refs.baseForm.setVal(item.value, vehicleInfo[item.value] || '');
              }
            }
            this.$refs.baseForm.setVal('plateNumberInfo', {
              plateNumber: vehicleInfo.plateNumber,
            });
            this.setFormValFromData(this.otherFormData, vehicleInfo);
          } else {
            this.$message({
              type: 'error',
              message: '车辆不存在！',
            });
          }
        }
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        let vehicle = {};
        for (let item of this.baseForm.form) {
          if (item.value) {
            vehicle[item.value] = formData[item.value];
          }
        }
        formData = {
          ...formData,
          vehicle: {
            ...vehicle,
            ...this.otherFormData,
          },
        };
        if (formData.plateNumberInfo) {
          if (formData.vehicle) {
            formData.vehicle.plateNumber = formData.plateNumberInfo.plateNumber;
          }
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          ...formData,
          ...formData.vehicle,
        };
        delete formData.vehicle;
        delete formData.plateNumberInfo;
      }
      // console.log('base提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      if (data.vehicle) {
        for (let item of this.baseForm.form) {
          if (item.value) {
            data[item.value] = data.vehicle[item.value] || '';
          }
        }
        data.plateNumberInfo = {
          plateNumber: data.vehicle.plateNumber,
        };
        this.setFormValFromData(this.otherFormData, data.vehicle);
      }
      this.$refs.baseForm.setVal(data);
      await this.jumpFromWarn();
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id) || (Boolean(this.$route.query.waringId && this.$refs.baseForm.getVal('plateNumberInfo'))),
        names: ['plateNumberInfo'],
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
